export default __webpack_public_path__ + "static/media/planta_mdc.53e0ad63.png";